<template>
<div  class=""  style="padding-top:70px;max-width:900px;margin:0 auto">

  <div class="row">
    <div class="col s4 m12"><img src="../assets/logo.png" style="height:90px;"/></div>
    <div class="col s8 m12"><h2>{{$socio.contatto.row.cognome}} {{$socio.contatto.row.nome}}</h2> </div>
  </div>
        

  <blockquote style="margin:0;"  v-if="sellaReady==false">

    <div class="yo-text-n yo-bg-color-secondary white yo-align-center" style="margin-top:20px;padding:10px 0;">ISCRIZIONI DA RINNOVARE</div> 
    
    <div class="row pad" v-for="item in $socio._nextquote"  :key="item.id" :class="'item_'+item.id" style="margin-top:20px;margin-bottom:20px;" v-if="item.nuovo==0">
      <div class="col s3 m1  yo-align-right">
        <el-switch style="display: block" v-model="item.selezionato" :inactive-value="0" :active-value="item.importo" active-color="#13ce66" inactive-color="#ff4949" active-text="" inactive-text=""></el-switch>
      </div>
      <div class="col s9 m2 yo-align-left" >{{item.id | items($teras._societa,'sigla')}}</div>
      <div class="col m8 yo-hidden-phone" >{{item.id | items($teras._societa,'nome')}}</div>
    </div>

    <div v-if="daRinnovare==false">Lei risulta già in regola con la quota sociale per l'anno corrente.</div>
      




  </blockquote>




  <div class="yo-text-n yo-bg-color-secondary white yo-align-center" style="margin-top:20px;padding:10px 0;">RIEPILOGO QUOTE SCELTE</div>

  <blockquote style="margin:0;"  v-if="dettaglioselezionate.length==0">
    <div style="padding:30px 10px;">
    Non si è selezionata alcuna quota da rinnovare, la preghiamo di selezionare la quota che desidera rinnovare tra quelle proposte sopra.
    </div>
  </blockquote> 


  <blockquote style="margin:0;" v-if="dettaglioselezionate.length>0"> 

    Ti preghiamo di verificare le proprie scelte e confermare per procedere al pagamento.
  
    <div class="row pad-in" v-for="item in dettaglioselezionate"  :key="item.id+item.anno" :class="'item_'+item.id+'_'+item.anno" style="margin-top:6px;margin-bottom:6px;" >
        <div class="col s5 m7 yo-align-right" >{{item.id | items($teras._societa,'sigla')}}</div>
        <div class="col s3 m2  yo-align-right">{{item.anno}}</div>
        <div class="col s4 m3  yo-align-right">{{item.importo  | money('€ ')}}</div>
    </div>

    <div class="row pad-in" style="margin-top:16px;margin-bottom:6px;" >
        <div class="col s8 m9 yo-align-right yo-text-bold" >TOTALE QUOTE</div>
        <div class="col s4 m3 yo-align-right yo-text-bold">{{importo | money('€ ')}}</div>
    </div>

    <div class="row pad-in" style="margin-top:16px;margin-bottom:0px;">
        <div class="col s8 m9 yo-align-right yo-text-bold" >COMMISSIONE BANCARIA</div>
        <div class="col s4 m3 yo-align-right yo-text-bold">{{commissione | money('€ ')}}</div>
    </div>

    <div class="row pad-in" style="margin-top:16px;margin-bottom:6px;" >
        <div class="col s8 m9 yo-align-right yo-text-bold" >TOTALE</div>
        <div class="col s4 m3 yo-align-right yo-text-bold">{{importoSella | money('€ ')}}</div>
    </div>

    <div class="row pad" style="margin-top:20px;">

      <div class="col s12 m6 offset-m6">
        <div v-if="importoSella>>parseFloat(commissione) && sellaReady==false" @click="onSella" class="yo-pointer yo-bg-color-secondary white yo-align-center" style="width:100%;border:none;height:48px;line-height:48px;">Conferma le tue scelte</div>
      </div>
    </div>
  
  </blockquote>  

  

  <blockquote style="margin:0;"  v-if="importoSella>>parseFloat(commissione) && sellaReady">
    <div class="yo-text-n yo-bg-color-secondary white yo-align-center" style="padding:10px 0;">MODALITÀ DI PAGAMENTO</div>
    <div style="padding:30px 10px;">
      Premendo il pulsante "Procedi al pagamento" verrete reindirizzati sul sito di Banca Sella dove potrete scegliere la modalità di pagamento da voi preferita tra quelle disponibili:
      <ul>
        <li>Carta di Credito</li>
        <li style="text-align:justify;">MyBank: bonifico immediato, rende più facili e più sicuri gli acquisti su Internet. Per quanto concerne la sicurezza, MyBank vi permette di pagare su Internet senza fornire agli esercenti alcun dettaglio del vostro conto corrente o altri dati relativi al pagamento. E per quanto riguarda la semplicità, con MyBank userete il vostro sistema di Online Banking, che già conoscete, da dove potrete dare ordine alla vostra banca di effettuare il pagamento a favore dell’esercente.</li>
        <li>Bonifico bancario: solo per i clienti Banca Sella</li>
      </ul>
      Una volta completata la procedura sul sito di Banca Sella vi ricordiamo di non chiudere il browser e ritornare al sito cliccando sul pulsante presente a fine procedura.
    </div>

    <div class="row pad" style="margin-top:20px;">
      <div class="col s12 m8 offset-m2">
        <a :href="sellaUri" class="yo-pointer yo-bg-color-secondary white yo-align-center" style="background-color:#24A445;display:block;width:100%;border:none;height:48px;line-height:48px;">Procedi al pagamento<!-- di {{importoSella | money('€ ')}} --></a>
      </div>
    </div>
      
    <!--
    <div class="col s12 m3" v-if="$socio.contatto.row.id==1">
      <el-button style="width:100%;"  @click="pagafinto()">PAGA FINTO</el-button>
    </div>
    -->
        
  </blockquote>


  <div class="clear" style="margin-top:30px;padding:30px 10px 0 10px;border-top:2px solid grey;">
    Se non si desidera completare ora il rinnovo può cliccare il pulsante "Indietro"
  </div>
    
  <div class="row clear" style="margin-top:20px;">
    <div class="col s12 m3">
        <el-button style="width:100%;"  @click="$router.push('/home')">Indietro</el-button>
    </div>
  </div>

</div>
</template>

<script>
import dbItem from '../teras/dbItem'

export default {
  name: 'contatto-rinnovo',
  components: {
  },
  data () {
      return {
         //:180, value5: '100',
         commissione: 1
         ,loading: {}
         ,versamento: {}
         ,banca: {}
         ,nextpayment: 0
         ,createToken:0

         ,addebito: 0
         
         ,sellaReady:false
         ,sellaUri:''
         ,sella: {}


      }
  },
  created () {
    //this.$teras.page.title = (this.$socio.contatto.row.id>0) ? 'Rinnovo '+this.$socio.contatto.row.id : 'Nuovo Contatto'
    console.log(this.$socio._nextquote)
      
    for (let item of this.$socio._nextquote){
      console.log(item)
      //if(item.id==100)
      if(item.nuovo==0)
        item.selezionato=item.importo
    }  
    
    this.online = new dbItem({table:'online'})
    this.online.new().then((data) => {
      this.online.row.contatto = this.$socio.contatto.row.id
      this.online.row.inseritoil=this.$moment().format('YYYY-MM-DD HH:mm:ss')
      this.online.row.sezione = 17
      this.online.row.importo = 0
      this.online.row.browser = this.$teras.browser.name +' '+ this.$teras.browser.version +' '+ this.$teras.browser.os
    })
      
  },
  beforeDestroy () {
  },
  methods: {
    async onSellaTest() {
      this.sellaReady = false
      this.online.row.quote = JSON.stringify(this.dettaglioselezionate)
      this.online.row.importo = this.importoSella
      await  this.online.save()

      var shopLogin = "GESPAY71800" //TEST  
      var args = {
        shopLogin: shopLogin
        ,uicCode: 242
        ,shopTransactionId:  this.online.row.id
        ,amount: 1 //TEST
        //,Language: 2";
        ,customInfo: 'TERAS_NOMINATIVO='+this.$socio.contatto.row.cognome+' '+this.$socio.contatto.row.nome+'*P1*TERAS_MOTIVO=Rinnovo'
      }
      var urlWS = "https://testecomm.sella.it/gestpay/gestpayws/WSCryptDecrypt.asmx?WSDL" //TEST
  
      this.$axios.post(this.$axios.apiUrl+'vue/sella',{url:urlWS,action:'Encrypt',args: args}).then((response) => {
        this.sella = response.data.data.result
        if(this.sella.TransactionResult=='OK'){
          this.sellaReady = true
          this.sellaUri =  "https://testecomm.sella.it/pagam/pagam.aspx" //TEST
          this.sellaUri += "?a="+shopLogin+"&b="+this.sella.CryptDecryptString
        }
      })
    },
    async onSella() {
      this.sellaReady = false
      this.online.row.quote = JSON.stringify(this.dettaglioselezionate)
      this.online.row.importo = this.importoSella
      await  this.online.save()
      
      var shopLogin = "9099135" //PRODUZIONE
      var args = {
        shopLogin: shopLogin
        ,uicCode: 242
        ,shopTransactionId:  this.online.row.id
        ,amount: this.importoSella //PRODUZIONE
        //  ,Language: 2";
        ,customInfo: 'TERAS_NOMINATIVO='+this.$socio.contatto.row.cognome+' '+this.$socio.contatto.row.nome+'*P1*TERAS_MOTIVO=Rinnovo'
      }
      var urlWS = "https://ecomms2s.sella.it/gestpay/gestpayws/WSCryptDecrypt.asmx?WSDL" //PRODUZIONE

      this.$axios.post(this.$axios.apiUrl+'vue/sella',{url:urlWS,action:'Encrypt',args: args}).then((response) => {
        this.sella = response.data.data.result
        if(this.sella.TransactionResult=='OK'){
            this.sellaReady = true
            this.sellaUri =  "https://ecomm.sella.it/pagam/pagam.aspx" //PRODUZIONE
            this.sellaUri += "?a="+shopLogin+"&b="+this.sella.CryptDecryptString
        }
      })
    },
    onCancel() {
        this.$router.go(-1)
    }
  },
  computed: {
    importoSella: function(){
      return parseFloat(this.importo)+parseFloat(this.commissione)
    },
    dettaglioselezionate: function(){
      var items = []
      for (let nq of this.$socio._nextquote){
        if(nq.selezionato==nq.importo ){
          for (let nqd of this.$socio._nextquoteDetail){
            if(nq.id==nqd.id){
              items.push(nqd)
            }
          }
        }
      }
      return items
    },
    daRinnovare: function(){
      var esito = false
      for (let item of this.$socio._nextquote){
        if(item.nuovo==0)
            esito = true          
      }
      return esito
    },
    importo: function () {
      var importo = 0
      for (let item of this.$socio._nextquote){
        if(item.selezionato==item.importo){
            importo+=parseFloat(item.importo)
          }          
      }
      return importo
    }
  }
}
</script>